import Suggester from './suggester';
import jQuery from 'jquery';
import DateRangePicker from "./daterange-picker";
import Cookie from "js-cookie";

let $ = jQuery;
let _analytics;

export default class searchForm {
    constructor(
        dom_id,
        url,
        current_location,
        analytics = null,
        datepicker_options = {},
        neighbours,
        datepickerLocale = 'en',
        isMobile = false,
        googleDecodeUrl = null
    ) {
        let form = this.form = $(dom_id);

        this.pickup_location_input = $('[data-role=pickup_name]', form);
        this.pickup_coord_input = $('[data-role=pickup_coord]', form);
        this.pickup_country = $('[data-role=pickup_country]', form);

        this.pickup_another = $('[data-role=return_another_location]', form);

        this.return_location_input = $('[data-role=return_name]', form);
        this.return_coord_input = $('[data-role=return_coord]', form);
        this.return_country = $('[data-role=return_country]', form);

        this.return_location_block = $('[data-role=return_location_block]', form);

        this.default_pickup_id = $('[data-role=default_pickup_id]', form);
        this.default_return_id = $('[data-role=default_return_id]', form);

        this.age_input = $('#age-input', form)
        this.age_checkbox = $('#age-checkbox', form)
        this.input_age_group = $('#input-age-group', form)

        let geocoder = null;


        const formDiv = document.getElementById('search_form');
        const start_date = formDiv.querySelector('[data-role=datetime-picker-start]');
        const start_hour = formDiv.querySelector('[data-role=date-picker-hour-start]');
        const start_min = formDiv.querySelector('[data-role=date-picker-min-start]');
        const start_input = formDiv.querySelector('#search_date_start');

        const end_date = formDiv.querySelector('[data-role=datetime-picker-end]');
        const end_hour = formDiv.querySelector('[data-role=date-picker-hour-end]');
        const end_min = formDiv.querySelector('[data-role=date-picker-min-end]');
        const end_input = formDiv.querySelector('#search_date_end');

        const date_range_panel = formDiv.querySelector('[data-role=date-range-panel]');
        const total_container = formDiv.querySelector('.total-container')

        const options = {
            start_date_widget: start_date,
            start_hour_widget: start_hour,
            start_min_widget: start_min,
            start_input: start_input,
            end_date_widget: end_date,
            end_hour_widget: end_hour,
            end_min_widget: end_min,
            end_input: end_input,
            panel_widget: date_range_panel,
            total_container: total_container
        };
        new DateRangePicker(options, datepickerLocale, isMobile);


        if (this.default_pickup_id.val() !== this.default_return_id.val()) {
            this.return_location_block.show();
            this.pickup_another.attr('checked', 'checked');
        }

        form.submit((event) => {
            this.submit(event);
        });


        const age = Cookie.get('AGE')
        if (age) {
            this.age_input.val(age);
        }

        if (this.age_input.val() < 30 || this.age_input.val() > 65) {
            this.age_checkbox.removeAttr('checked')
            this.input_age_group.show(0, function () {
                $(this).css('display', 'flex');
            });
        }


        this.age_checkbox.change(() => {
            if (this.age_checkbox.is(':checked')) {
                this.input_age_group.hide(0)
            } else {
                this.input_age_group.show(0, function () {
                    $(this).css('display', 'flex');
                });
            }
        })


        // this.age_input.on('input', this.validateAgeInout);

        this.pickup_another.change(() => {
            if (this.pickup_another.is(':checked')) {
                this.return_location_block.slideDown(100)
            } else {
                this.return_location_block.slideUp(100)
            }
        });

        this.suggester = new Suggester(url, googleDecodeUrl, current_location, neighbours);

        this.bindAutocomplete(this.pickup_location_input, this.pickup_coord_input, this.pickup_country, this.default_pickup_id);
        this.bindAutocomplete(this.return_location_input, this.return_coord_input, this.return_country, this.default_return_id);

        $(".detect-location-btn").on("click", async (event) => {
            const coords = await this.getUserLocation(event);
            const locationInput = this.pickup_location_input;
            const placeIdInput = this.default_pickup_id;
            const countryInput = this.pickup_country;
            this.pickup_coord_input.val(coords.latitude + ', ' + coords.longitude);

            if (geocoder) {
                fillUserLocation();
            } else {
                $.when(
                    $.getScript(`https://maps.googleapis.com/maps/api/js?key=${GOOGLE_API_KEY}&language=${API_LOCALE}`),
                    $.Deferred(function (deferred) {
                        $(deferred.resolve);
                    })
                ).done(function () {
                    geocoder = new google.maps.Geocoder();
                    fillUserLocation();
                });
            }

            function fillUserLocation() {
                geocoder
                    .geocode({
                        location: {
                            lat: coords.latitude,
                            lng: coords.longitude
                        }
                    }).then((response) => {
                    let address = response.results.find(el => !el.formatted_address.toLowerCase().includes('unnamed'));
                    let formattedAddress = address.formatted_address;
                    let placeId = address.place_id;
                    let country = address.address_components.find(el => el.types.includes('country')).short_name;

                    locationInput.val(formattedAddress);
                    placeIdInput.val(placeId);
                    countryInput.val(country);
                })
                    .catch((e) => console.log('Can\'t detect location due to ' + e));
            }
        });

        _analytics = analytics;
        const loader = document.getElementById("loader");
        if (loader) {
            loader.style.display = "none";
        }
    }

    /**
     * form submit handler
     */
    submit(event) {
        this.resetErrors();
        if (searchForm.isEmpty(this.pickup_location_input)) {
            this.showError(event);
        }

        if (this.pickup_another.is(':checked') && searchForm.isEmpty(this.return_location_input)) {
            this.showError(event)
        }

    }

    async getUserLocation(event) {
        event.stopPropagation();
        if ("geolocation" in navigator) {
            return new Promise((resolve, reject) => {
                navigator.geolocation.getCurrentPosition(position => {
                    if (position.coords) {
                        resolve(position.coords);
                    } else {
                        reject(new Error('Can\'t detect location'));
                    }
                });
            });
        }
        return;
    }

    showError(event) {
        event.preventDefault();
        this.notifyErrors();
        this.form.trigger('submit_error.search_form');
        throw new Error('Please select valid location');
    }

    resetErrors() {
        this.pickup_location_input.removeClass('has-error');
        this.return_location_input.removeClass('has-error');
    }

    notifyErrors() {
        let error = false;

        if (searchForm.isEmpty(this.pickup_location_input)) {
            this.pickup_location_input.addClass('has-error');
            error = true;
        }

        if (this.pickup_another.is(':checked') && searchForm.isEmpty(this.return_location_input)) {
            this.return_location_input.addClass('has-error');
            error = true;
        }

        if (error) {
            window.setTimeout(() => this.resetErrors(), 3000);
        }
    }

    onDateChanged(changedStartDate, changedEndDate) {
        if (_analytics) {
            _analytics.trackDateChanged(true);
        }
    }

    static isEmpty(location) {
        return (location.val().replace(' ', '').length === 0);
    }

    bindAutocomplete(input, geo_input, country_input, id_input) {
        // searchForm.assignReset(input);

        this.suggester.bind(
            input,
            searchForm._ash_select(input, geo_input, country_input, id_input),
            searchForm._ash_start_loading(input),
            searchForm._ash_end_loading(input),
            searchForm._ash_change(input, this)
        )
    }

    //
    // validateAgeInout() {
    //     $(this).val($(this).val().replace(/[^0-9]/g, ''));
    // }

    /*static assignReset(input) {
        let _reset = $('#' + input.attr('id') + '_reset');
        _reset.click(() => {
            input.val('').change().focus();
            _reset.hide();
        });

        let _reset_closure = () => {
            if (!input.val().length)
                _reset.hide();
            else
                _reset.show();
        };

        input.keyup(_reset_closure);

        input.data('reset_closure', _reset_closure);
        _reset_closure();
    }*/

    /**
     * ash means autoselect handler
     *
     * @param input
     * @param latlngInput
     * @param countryInput
     * @param id_input
     * @returns {function(*)}
     * @private
     */
    static _ash_select(input, latlngInput, countryInput, id_input) {
        return (data) => {
            latlngInput.val('');
            countryInput.val('');

            if (data.latLng !== undefined) {
                latlngInput.val(data.latLng);
                countryInput.val(data.country);
            } else if (data.aid) {
                id_input.val(data.aid);
            }

            input.val(data.value);
            // input.data('reset_closure')();

            let type;

            if (_analytics) {
                (input.attr('id').match(/pickup/)) ? type = 'pickup' : type = 'return';
                _analytics.trackLocationChanged(type);
            }
        };
    }

    /**
     * ash means autoselect handler
     *
     * @param input
     * @returns {function()}
     * @private
     */
    static _ash_start_loading(input) {
        let indicator = $('#' + input.attr('id') + '_indicator');
        let reset = $('#' + input.attr('id') + '_reset');

        return () => {
            $('.autocomplete-locations').addClass('blur')
            reset.hide();
            indicator.show();
        };
    }

    /**
     * ash means autoselect handler
     *
     * @param input
     * @returns {function()}
     * @private
     */
    static _ash_end_loading(input) {
        let indicator = $('#' + input.attr('id') + '_indicator');

        return () => {
            // input.data('reset_closure')();
            $('.autocomplete-locations').removeClass('blur')
            indicator.hide();
        };
    }

    static _ash_change(input, form) {
        return () => {
            // input.data('reset_closure')();

            if (input.attr('id').match(/pickup/)) {
                form.pickup_coord_input.val();
                form.pickup_country.val();
                form.default_pickup_id.val();
            } else {
                form.return_coord_input.val();
                form.return_country.val();
                form.default_return_id.val();
            }
        }
    }
}
